import { render } from "./RemoveNode.vue?vue&type=template&id=616dc2ee"
import script from "./RemoveNode.vue?vue&type=script&lang=ts"
export * from "./RemoveNode.vue?vue&type=script&lang=ts"
script.render = render

export default script